/*
 * @Author: your name
 * @Date: 2021-12-28 17:16:13
 * @LastEditTime: 2024-03-08 18:14:44
 * @LastEditors: niuzijie
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \yl-wxcx-coupon-front\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import routesMobile from './routerMobile'
import routesPc from './routerPc'
import publicRoutes from './router'
Vue.use(VueRouter)

export default function() {
  console.log(navigator.userAgent)
  const platform = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  const routesNew = platform ? routesMobile : routesPc
  const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [...routesNew, ...publicRoutes]
  })
  router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  })

  return router
}
